<div>
    <span>
        {{recommendationLabel | translate}}
    </span>
    <div>
            <span class="risk-status">
                {{riskStatus }} : {{recommendationSuggestion }}
            </span>      
            <hr>
            <div class="guideline-message" [innerHTML]="recommendationGuidelines.guideline">
            </div>
    </div>
</div>